<template lang="pug">
    include ../media/pug/mixins.pug
    +b.document-page
        menu-panel
        template(v-if="!isMobile")
            +e.content
                +e.SIDEBAR.sidebar(v-if="$route.name === 'Document'")
                +e.view
                    the-order-view(v-if="getCurrentSidebarTab === 'OrdersList'")
                    the-viewed-documents(v-else-if="getCurrentSidebarTab === 'ViewedDocuments'")
                    the-document-view(v-else-if="$route.params.id")
                    error-box(v-else)
        template(v-else)
            +e.content
                +e.view
                    the-document-view(v-if="$route.params.id")
                    error-box(v-else)

</template>

<script>
import { mapGetters } from 'vuex';
import MenuPanel from '@/components/partials/MenuPanel';
import TheDocumentView from '@/components/document-views/TheDocumentView';
import Sidebar from '@/components/partials/Sidebar';
import api from '@/helpers/api';

const TheViewedDocuments = () => import('@/components/document-views/TheViewedDocuments');
const TheOrderView = () => import('@/components/document-views/TheOrderView');
const ErrorBox = () => import('@/components/document-views/ErrorBox');

export default {
    components: {
        MenuPanel,
        Sidebar,
        TheDocumentView,
        TheViewedDocuments,
        TheOrderView,
        ErrorBox
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getGeneralInfo',
            'getCurrentSidebarTab',
            'isMainImgLandscape',
            'getModalBodyComponent'
        ])
    },
    watch: {
        $route(to, from) {
            if (from.query.rotate !== to.query.rotate) {
                this.checkLandScape(to.query.rotate);
            }
        }
    },
    created() {
        if (this.$route.params.id) {
            let { negative = 0, page = 1, rotate = 0 } = this.$route.query;
            if (negative !== '1') {
                negative = '0';
            }
            if (page < 1 || page > this.getGeneralInfo.maxPages || Number.isNaN(Number(page))) {
                page = 1;
            }
            if (Number.isNaN(Number(rotate))) {
                rotate = 0;
            } else {
                const availableDegrees = [0, 90, 180, 270, 360];
                const negativeDegrees = availableDegrees.map(degree => degree * -1);
                const degrees = [...availableDegrees, ...negativeDegrees];
                const closest = degrees.reduce(
                    (prev, curr) => (Math.abs(curr - rotate) < Math.abs(prev - rotate) ? curr : prev)
                );
                rotate = Math.abs(closest) === 360 ? 0 : closest;
            }
            this.checkLandScape(rotate);
            this.$router.push({
                replace: true,
                query: {
                    page,
                    rotate,
                    negative
                }
            });
        }
    },
    mounted() {
        if (this.$route.params.id) this.checkUserActivity();
    },
    methods: {
        logoutUser() {
            api.post('/esia-logout').then(() => {
                setTimeout(() => {
                    this.$store.dispatch('showModal', {
                        component: 'ModalSession',
                        session: 'fatal'
                    });
                }, 500);
            });
        },
        checkUserActivity() {
            let delay = 0;
            const events = ['scroll', 'touchstart', 'keypress', 'mousemove', 'mousedown'];
            events.forEach(item => window.addEventListener(item, () => {
                if (this.getModalBodyComponent !== 'ModalSession') delay = 0;
            }, true));
            setInterval(() => {
                delay += 1;
                if (delay === 300) {
                    this.$store.dispatch('closeModal');
                    setTimeout(() => {
                        this.$store.dispatch('showModal', {
                            component: 'ModalSession',
                            session: 'not fatal'
                        });
                    }, 500);
                }
                if (delay === 3600) {
                    this.$store.dispatch('closeModal');
                    this.logoutUser();
                }
            }, 1000);
        },
        checkLandScape(degrees) {
            if ([90, 270].includes(Math.abs(degrees))) {
                this.$store.commit('SET_MAIN_IMG_IS_LANDSCAPE', true);
            } else if (this.isMainImgLandscape) {
                this.$store.commit('SET_MAIN_IMG_IS_LANDSCAPE', false);
            }
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/pages/document.sass"></style>
